var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path21, _rect3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanThumbsUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 136,
    viewBox: "0 0 137 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 136,
    height: 136,
    rx: 68,
    fill: "#D2EFF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_763_18675",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 137,
    height: 136
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 136,
    height: 136,
    rx: 68,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_763_18675)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.667 32.1038C46.667 19.9371 56.5301 10.074 68.6968 10.074C80.8635 10.074 90.7266 19.9371 90.7266 32.1038V78.2734H46.667V32.1038Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8094 96.2355C69.6183 96.2355 80.002 86.1581 80.002 73.7269C80.002 61.2957 69.6183 51.2183 56.8094 51.2183C44.0004 51.2183 33.6167 61.2957 33.6167 73.7269C33.6167 86.1581 44.0004 96.2355 56.8094 96.2355Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.032 71.5494C71.8817 71.5494 81.4877 62.7723 81.4877 51.9451C81.4877 41.118 71.8817 32.3408 60.032 32.3408C48.1823 32.3408 38.5762 41.118 38.5762 51.9451C38.5762 62.7723 48.1823 71.5494 60.032 71.5494Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4004 96.2355C88.2094 96.2355 98.5931 86.1581 98.5931 73.7269C98.5931 61.2957 88.2094 51.2183 75.4004 51.2183C62.5915 51.2183 52.2078 61.2957 52.2078 73.7269C52.2078 86.1581 62.5915 96.2355 75.4004 96.2355Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.623 71.5494C90.4727 71.5494 100.079 62.7723 100.079 51.9451C100.079 41.118 90.4727 32.3408 78.623 32.3408C66.7733 32.3408 57.1672 41.118 57.1672 51.9451C57.1672 62.7723 66.7733 71.5494 78.623 71.5494Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4744 17.8559C54.4744 17.2246 54.9861 16.7129 55.6174 16.7129H81.7749C82.4062 16.7129 82.9179 17.2246 82.9179 17.8559V45.3907C82.9179 53.2452 76.5506 59.6125 68.6961 59.6125C60.8417 59.6125 54.4744 53.2452 54.4744 45.3907V17.8559Z",
    fill: "#CC8B57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.457 36.5617C78.457 36.5348 78.4789 36.5129 78.5058 36.5129H82.6978C84.976 36.5129 86.8228 38.3597 86.8228 40.6379C86.8228 42.9161 84.976 44.7629 82.6978 44.7629H78.5058C78.4789 44.7629 78.457 44.741 78.457 44.7141V36.5617Z",
    fill: "#CC8B57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5718 40.6379C50.5718 38.3597 52.4186 36.5129 54.6967 36.5129H58.8888C58.9157 36.5129 58.9375 36.5348 58.9375 36.5617V44.7141C58.9375 44.741 58.9157 44.7629 58.8888 44.7629H54.6967C52.4186 44.7629 50.5718 42.9161 50.5718 40.6379Z",
    fill: "#CC8B57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4743 16.6343L68.4172 11.6843L82.9178 16.6343L84.591 21.0342L82.9178 23.8411C82.9178 23.8411 76.842 25.4943 70.0903 30.0997C63.3387 34.705 54.4743 36.9841 54.4743 36.9841L52.2434 26.5342L54.4743 16.6343Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8989 51.9514C77.8989 51.9514 77.3412 58.2445 77.3412 62.2281C77.3412 64.8289 79.8937 67.2319 83.5126 69.3319C96.145 76.6622 106.647 88.5854 105.557 103.15L104.786 113.448L94.386 116.913V128.124V163.911L82.8306 178.725H53.942L42.3866 163.911L38.2778 129.704L23.8979 128.124L27.4543 98.4573C28.9398 86.0655 38.3655 76.5142 49.7789 71.4648C55.4144 68.9715 60.0519 65.8844 60.0519 62.4761C60.0519 58.5118 59.4942 51.3618 59.4942 51.3618L77.8989 51.9514Z",
    fill: "#CC8B57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_763_18675",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 51,
    width: 97,
    height: 128
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8989 51.9516C77.8989 51.9516 77.3412 58.2447 77.3412 62.2283C77.3412 67.044 86.0924 71.1815 94.1601 73.9727C102.439 76.8371 109.772 82.2784 113.767 90.0754L119.824 101.898L100.499 130.196C100.499 130.196 98.4199 141.771 96.7079 150.85C95.3445 158.08 95.6229 169.651 95.6229 169.651L82.8306 178.725H53.942L42.3866 163.911L38.92 128.585L23.8979 128.124L27.4543 98.4575C28.9398 86.0658 38.3655 76.5144 49.7789 71.465C55.4144 68.9718 60.0519 65.8846 60.0519 62.4764C60.0519 58.512 59.4942 51.3621 59.4942 51.3621L77.8989 51.9516Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_763_18675)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8989 51.9516C77.8989 51.9516 77.3412 58.2447 77.3412 62.2283C77.3412 64.8291 79.8937 67.2321 83.5126 69.3321C96.145 76.6625 106.647 88.5856 105.557 103.15L104.786 113.448L94.386 116.914V128.124V163.911L82.8306 178.725H53.942L42.3866 163.911L38.2778 129.284L23.8979 128.124L27.4543 98.4575C28.9398 86.0658 38.3655 76.5144 49.7789 71.465C55.4144 68.9718 60.0519 65.8846 60.0519 62.4764C60.0519 58.512 59.4942 51.3621 59.4942 51.3621L77.8989 51.9516Z",
    fill: "#CC8B57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3209 65.5239C44.3209 65.5239 53.3502 78.2986 68.9755 78.1531C84.6007 78.0077 93.0723 65.5239 93.0723 65.5239L107.458 74.8157L122.166 101.321C122.166 101.321 108.078 120.891 105.078 123.031C102.077 125.171 98.1561 129.619 98.1561 129.619L95.5416 163.912L72.9745 188.525L55.0977 177.586L42.3867 163.912L39.1174 127.605L23.1667 123.827L29.9353 75.525L44.3209 65.5239Z",
    fill: "#002D58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.794 65.5938C50.794 65.5938 60.8219 116.082 62.6387 130.497C64.4555 144.911 63.1859 188.981 63.1859 188.981L33.1418 185.562L38.9196 132.004C38.9196 132.004 41.2306 126.306 41.2306 122.888C41.2306 119.469 41.0837 68.0764 41.0837 68.0764L50.794 65.5938Z",
    fill: "#338DE3",
    stroke: "#338DE3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5251,
    y: 104.049,
    width: 10.4296,
    height: 3.90127,
    rx: 1.26081,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7593 65.5938C86.7593 65.5938 78.6855 115.709 77.2257 130.497C75.7659 145.284 77.0536 163.911 77.0536 163.911L78.2092 188.981H103.631L99.0089 132.004C99.0089 132.004 96.6979 127.446 96.5462 122.52C96.3945 117.594 96.4696 68.0764 96.4696 68.0764L86.7593 65.5938Z",
    fill: "#338DE3",
    stroke: "#338DE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2053 91.0398C48.7919 91.0398 48.4636 91.2654 48.4636 91.5385L48.7189 94.3232C48.7433 94.4894 48.9561 94.6201 49.2053 94.6201C49.4607 94.6201 49.6735 94.4894 49.7039 94.3232L49.9532 91.5385C49.9532 91.2654 49.6249 91.0398 49.2053 91.0398ZM45.3085 93.3196C45.0652 93.1831 44.7004 93.3493 44.4937 93.6996C44.2809 94.0499 44.3174 94.4418 44.5667 94.5784L47.1568 95.7599C47.321 95.8133 47.5399 95.7005 47.6675 95.4868C47.7952 95.273 47.7831 95.0296 47.6493 94.9227L45.3085 93.3196ZM53.8547 94.5784C54.098 94.4418 54.1344 94.0499 53.9277 93.6996C53.7149 93.3493 53.3501 93.1831 53.1069 93.3196L50.766 94.9227C50.6323 95.0296 50.6201 95.273 50.7478 95.4868C50.8755 95.7005 51.0944 95.8133 51.2585 95.7599L53.8547 94.5784ZM44.5667 98.1354C44.3174 98.2779 44.2809 98.6698 44.4937 99.0201C44.7004 99.3704 45.0652 99.5366 45.3085 99.4001L47.6493 97.797C47.7831 97.6842 47.7952 97.4407 47.6675 97.227C47.5399 97.0132 47.321 96.9004 47.1568 96.9598L44.5667 98.1354ZM51.2585 96.9598C51.0944 96.9004 50.8755 97.0132 50.7478 97.227C50.6201 97.4407 50.6323 97.6842 50.766 97.797L53.1069 99.4001C53.3501 99.5366 53.7149 99.3704 53.9277 99.0201C54.1344 98.6698 54.098 98.2779 53.8547 98.1354L51.2585 96.9598ZM49.2114 98.0991C48.9561 98.0991 48.7433 98.2238 48.7189 98.3901L48.4636 101.175C48.4636 101.454 48.7919 101.679 49.2053 101.679C49.6249 101.679 49.9532 101.454 49.9532 101.175L49.7039 98.3901C49.6735 98.2238 49.4607 98.0991 49.2114 98.0991Z",
    fill: "#FFE190"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0967 40.206C78.0967 39.0903 77.184 38.1858 76.0581 38.1858C74.9322 38.1858 74.0195 39.0903 74.0195 40.206",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4974 40.206C63.4974 39.0903 62.5847 38.1858 61.4588 38.1858C60.3329 38.1858 59.4202 39.0903 59.4202 40.206",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7497 47.5685C70.0117 47.5685 71.0348 46.7561 71.0348 46.4462C71.0348 46.1363 70.0117 45.885 68.7497 45.885C67.4877 45.885 66.4646 46.1363 66.4646 46.4462C66.4646 46.7561 67.4877 47.5685 68.7497 47.5685Z",
    fill: "#AD764A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4187 50.3464C64.4187 52.299 66.6334 53.2926 68.5074 53.2926C70.3814 53.2926 72.7665 52.299 72.7665 50.3464",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.023 122.111C128.022 117.455 119.824 101.898 119.824 101.898C115.323 105.501 109.283 115.758 106.94 118.646C106.009 118.301 98.1559 118.068 92.2997 116.336C90.5428 115.758 88.2004 116.336 87.0291 112.871L82.9299 125.576C91.7142 126.154 101.421 131.478 106.94 130.774C111.951 130.134 128.023 130.774 128.023 122.111Z",
    fill: "#CC8B57"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5726 126.507C79.3181 126.388 76.7767 125.951 75.8539 124.931C74.9312 123.912 75.4821 124.132 74.9718 123.166C74.4616 122.2 74.261 122.381 73.3704 121.459C72.4798 120.538 73.3349 119.554 73.0119 118.857C72.7699 118.335 72.2099 118.533 72.2913 117.042C72.3456 116.048 73.0515 115.01 73.0786 114.513C73.1058 114.016 70.6318 110.611 77.918 110.611C79.6107 110.701 81.4818 111.115 86.8897 113.116C86.5667 119.034 88.0171 123.858 81.5726 126.507Z",
    fill: "#CC8B57"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.316 120.663L115.169 120.331C114.458 120.125 113.319 119.968 112.113 119.802C111.407 119.704 110.679 119.604 110.033 119.492C108.322 119.194 106.964 118.655 106.941 118.646L107.087 118.472C107.111 118.48 108.412 119.025 110.107 119.32C110.75 119.431 111.476 119.532 112.178 119.628C113.392 119.796 114.539 119.955 115.264 120.165L116.412 120.497L116.316 120.663Z",
    fill: "#AD764A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6884 118.255C87.128 117.925 87.5599 113.183 86.8966 112.633C86.1042 111.977 85.6968 109.493 85.7141 108.004C85.743 105.525 86.6596 103.875 86.0791 103.346C85.0359 102.395 83.2612 103.766 81.8673 105.963C81.2088 108.494 81.6731 111.282 80.5291 112.329C67.6599 124.105 85.9912 119.032 87.6884 118.255Z",
    fill: "#CC8B57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_763_18675",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 51,
    width: 19,
    height: 19
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.881 51.9389C77.881 51.9389 77.3233 58.232 77.3233 62.2156C77.3233 71.7775 60.034 72.617 60.034 62.4637C60.034 58.4993 59.4763 51.3494 59.4763 51.3494L77.881 51.9389Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_763_18675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0459 23.5352C87.6143 23.5354 88.075 23.9961 88.0752 24.5645V45.9092C88.0752 54.894 80.7915 62.1777 71.8066 62.1777C66.3703 62.1777 61.5568 59.5115 58.6025 55.415C61.1777 58.0001 64.7416 59.5996 68.6787 59.5996C76.533 59.5994 82.9004 53.2323 82.9004 45.3779V23.5352H87.0459Z",
    fill: "#AD764A"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0083 22.3977C38.7992 22.3978 40.2505 23.8499 40.2505 25.6409C40.2503 27.4317 38.7991 28.8829 37.0083 28.8831C35.2174 28.8831 33.7653 27.4318 33.7651 25.6409C33.7651 23.8499 35.2173 22.3977 37.0083 22.3977ZM37.0083 24.0188C36.1128 24.0188 35.3862 24.7454 35.3862 25.6409C35.3864 26.5363 36.1129 27.262 37.0083 27.262C37.9036 27.2618 38.6293 26.5362 38.6294 25.6409C38.6294 24.7455 37.9037 24.0189 37.0083 24.0188Z",
    fill: "#0071DC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36255 44.0171C10.1534 44.0172 11.6047 45.4693 11.6047 47.2603C11.6046 49.0511 10.1534 50.5023 8.36255 50.5024C6.57163 50.5024 5.11952 49.0511 5.11938 47.2603C5.11938 45.4692 6.57154 44.0171 8.36255 44.0171ZM8.36255 45.6382C7.46705 45.6382 6.74048 46.3648 6.74048 47.2603C6.74062 48.1556 7.46713 48.8813 8.36255 48.8813C9.25785 48.8812 9.9835 48.1556 9.98364 47.2603C9.98364 46.3648 9.25793 45.6383 8.36255 45.6382Z",
    fill: "#29B8FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.2399,
    cy: 107.836,
    rx: 2.15302,
    ry: 2.15303,
    fill: "#FFC220"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.665,
    cy: 57.4958,
    rx: 2.15302,
    ry: 2.15303,
    fill: "#FF7208"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.5329,
    cy: 2.91694,
    rx: 2.15303,
    ry: 2.15303,
    fill: "#FF7208"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0358,
    cy: 94.4987,
    rx: 2.15303,
    ry: 2.15303,
    fill: "#B253B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.479 14.7801C26.3095 13.9082 25.4653 13.3388 24.5934 13.5083C23.7215 13.6778 23.1521 14.522 23.3215 15.3939L23.7819 17.762C23.9513 18.6339 24.7955 19.2033 25.6675 19.0338C26.5394 18.8643 27.1088 18.0201 26.9393 17.1482L26.479 14.7801Z",
    fill: "#29B8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.21654,
    height: 5.62895,
    rx: 1.60827,
    transform: "matrix(-1 0 0 1 75.0747 8.39502)",
    fill: "#0071DC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.55 15.8127C105.085 15.1034 104.943 14.095 104.234 13.5604C103.525 13.0259 102.516 13.1676 101.982 13.877L100.53 15.8036C99.9952 16.513 100.137 17.5214 100.846 18.0559C101.556 18.5905 102.564 18.4487 103.099 17.7394L104.55 15.8127Z",
    fill: "#FF7208"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.594 40.8769C120.956 40.0655 120.591 39.1148 119.779 38.7536C118.968 38.3923 118.017 38.7572 117.656 39.5687L116.675 41.7725C116.313 42.5839 116.678 43.5346 117.49 43.8959C118.301 44.2571 119.252 43.8922 119.613 43.0808L120.594 40.8769Z",
    fill: "#FFC220"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.661 61.2778C125.49 60.9595 125.904 60.0292 125.586 59.2C125.267 58.3707 124.337 57.9566 123.508 58.2749L121.256 59.1394C120.427 59.4577 120.012 60.388 120.331 61.2172C120.649 62.0464 121.579 62.4606 122.408 62.1423L124.661 61.2778Z",
    fill: "#B253B7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3665 11.1432C55.1957 10.8249 55.6099 9.89467 55.2916 9.06544C54.9733 8.23622 54.043 7.82204 53.2138 8.14035L50.9616 9.00488C50.1324 9.32319 49.7182 10.2535 50.0365 11.0827C50.3548 11.9119 51.2851 12.3261 52.1143 12.0078L54.3665 11.1432Z",
    fill: "#B253B7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.703 70.1568C116.274 70.3207 116.605 70.9168 116.441 71.4884L115.402 75.1102C115.239 75.6817 114.642 76.0122 114.071 75.8483L111.484 75.1065L110.742 77.6935C110.583 78.2477 110.018 78.5752 109.463 78.4451L109.41 78.4316L106.823 77.6898L106.082 80.2768C105.918 80.8483 105.322 81.1787 104.75 81.0149C104.179 80.851 103.848 80.2548 104.012 79.6833L105.051 76.0615C105.214 75.49 105.811 75.1595 106.382 75.3234L108.969 76.0652L109.711 73.4782C109.875 72.9067 110.471 72.5762 111.042 72.7401L113.629 73.4819L114.371 70.8949C114.535 70.3234 115.131 69.9929 115.703 70.1568Z",
    fill: "#0071DC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.318 40.1073C135.767 40.33 135.14 40.0636 134.917 39.5124L133.506 36.019C133.283 35.4677 133.549 34.8403 134.1 34.6176L136.596 33.6094L135.588 31.1141C135.372 30.5795 135.616 29.9734 136.133 29.734L136.182 29.7127L138.678 28.7045L137.67 26.2092C137.447 25.6579 137.713 25.0305 138.264 24.8078C138.816 24.5851 139.443 24.8514 139.666 25.4027L141.077 28.8961C141.3 29.4473 141.034 30.0748 140.482 30.2975L137.987 31.3057L138.995 33.801C139.218 34.3522 138.952 34.9796 138.4 35.2024L135.905 36.2104L136.913 38.7059C137.136 39.2571 136.87 39.8845 136.318 40.1073Z",
    fill: "#008BFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.719 33.7024C105.297 33.5648 105.878 33.9221 106.015 34.5005L106.888 38.1659C107.025 38.7443 106.668 39.3248 106.089 39.4624L103.471 40.0854L104.094 42.7036C104.228 43.2645 103.896 43.8273 103.348 43.9864L103.296 44.0001L100.678 44.6231L101.301 47.2413C101.439 47.8197 101.081 48.4001 100.503 48.5378C99.9246 48.6754 99.3442 48.3181 99.2065 47.7397L98.3343 44.0742C98.1967 43.4958 98.554 42.9154 99.1324 42.7778L101.751 42.1547L101.128 39.5366C100.99 38.9582 101.347 38.3777 101.926 38.2401L104.544 37.6171L103.921 34.9989C103.783 34.4205 104.14 33.84 104.719 33.7024Z",
    fill: "#FFC220"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2336 68.0329C30.8436 68.4816 30.1636 68.5291 29.7149 68.1391L26.8713 65.6672C26.4226 65.2771 26.3751 64.5972 26.7651 64.1485L28.5308 62.1173L26.4996 60.3517C26.0645 59.9735 26.0066 59.3226 26.3592 58.8744L26.3934 58.833L28.1591 56.8018L26.1279 55.0362C25.6792 54.6461 25.6317 53.9662 26.0217 53.5175C26.4118 53.0688 27.0917 53.0212 27.5404 53.4113L30.384 55.8832C30.8327 56.2732 30.8803 56.9532 30.4902 57.4019L28.7246 59.433L30.7557 61.1987C31.2044 61.5887 31.252 62.2687 30.8619 62.7174L29.0965 64.7483L31.1274 66.5142C31.5761 66.9042 31.6237 67.5842 31.2336 68.0329Z",
    fill: "#FF7208"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2036 102.983C17.0598 103.56 16.4756 103.911 15.8987 103.767L12.2428 102.856C11.6659 102.712 11.3149 102.128 11.4587 101.551L12.1098 98.9395L9.49843 98.2885C8.93903 98.149 8.59198 97.5954 8.70261 97.0359L8.71433 96.9835L9.36541 94.3721L6.75407 93.7211C6.17719 93.5772 5.82613 92.993 5.96997 92.4161C6.1138 91.8392 6.69805 91.4882 7.27493 91.632L10.9308 92.5435C11.5077 92.6873 11.8587 93.2716 11.7149 93.8485L11.0638 96.4598L13.6752 97.1109C14.2521 97.2547 14.6031 97.839 14.4593 98.4159L13.8083 101.027L16.4195 101.678C16.9964 101.822 17.3475 102.406 17.2036 102.983Z",
    fill: "#B253B7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62083 65.1918L7.82636 70.5493L3.85814 67.7707L8.62083 65.1918Z",
    fill: "#0071DC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4322 28.9346L21.8543 33.7789H17.01L19.4322 28.9346Z",
    fill: "#FFC220"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.612 106.033L118.939 107.014L116.023 110.883L113.612 106.033Z",
    fill: "#FF7208"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.116 86.2406L126.324 90.108L124.747 85.5276L130.116 86.2406Z",
    fill: "#008BFC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3412 44.4974L43.4487 46.2995L39.964 49.6646L38.3412 44.4974Z",
    fill: "#B253B7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4697 78.6079C18.2606 78.608 19.7119 80.0602 19.7119 81.8511C19.7118 83.6419 18.2605 85.0931 16.4697 85.0933C14.6788 85.0933 13.2267 83.642 13.2266 81.8511C13.2266 80.0601 14.6787 78.6079 16.4697 78.6079ZM16.4697 80.229C15.5742 80.229 14.8477 80.9556 14.8477 81.8511C14.8478 82.7465 15.5743 83.4722 16.4697 83.4722C17.365 83.472 18.0907 82.7464 18.0908 81.8511C18.0908 80.9557 17.3651 80.2291 16.4697 80.229Z",
    fill: "#FF7208"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4592 83.9504C80.2501 83.9506 81.7014 85.4027 81.7014 87.1936C81.7013 88.9844 80.25 90.4357 78.4592 90.4358C76.6683 90.4358 75.2162 88.9845 75.2161 87.1936C75.2161 85.4026 76.6682 83.9504 78.4592 83.9504ZM78.4592 85.5715C77.5637 85.5715 76.8372 86.2981 76.8372 87.1936C76.8373 88.089 77.5638 88.8147 78.4592 88.8147C79.3545 88.8146 80.0802 88.0889 80.0803 87.1936C80.0803 86.2982 79.3546 85.5717 78.4592 85.5715Z",
    fill: "#B253B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanThumbsUp);
export default __webpack_public_path__ + "static/media/WomanThumbsUp.c0b586229fad0d85b7420042cc3d1b60.svg";
export { ForwardRef as ReactComponent };